import React from 'react';

import {DataFrame} from 'data-frames/DataFrameTypes';
import {VisualizationType} from 'insights/analytics-visualizations/AnalyticsVisualizationTypes';
import makeVisualizationConfig from 'insights/universal-blocks/makeVisualizationConfig';

import ModelingDashboardBlock, {SharedModelingBlockProps} from './ModelingDashboardBlock';

export const SEARCH_RANKINGS_BLOCK_TITLE = 'Model class comparisons';
export const SEARCH_RANKINGS_BLOCK_DESCRIPTION =
  'This table compares the relative performance of all models trained. Only the best model as measured by Ranking score is used in your analysis.';

/** @package */
export const VISUALIZATION_TYPE = VisualizationType.TABLE;
/** @package */
export const BASE_VISUALIZATION_PARAMETERS = {
  displayColumnsJson: null,
};

export interface SearchRankingsBlockProps extends SharedModelingBlockProps {
  dataFrame: DataFrame;
}

export default function SearchRankingsTableBlock({
  dataFrame,
  ...sharedModelingBlockProps
}: SearchRankingsBlockProps): JSX.Element {
  const visualizationConfig = makeVisualizationConfig(VISUALIZATION_TYPE, BASE_VISUALIZATION_PARAMETERS);

  return (
    <ModelingDashboardBlock
      {...sharedModelingBlockProps}
      blockTitle={SEARCH_RANKINGS_BLOCK_TITLE}
      blockDescription={SEARCH_RANKINGS_BLOCK_DESCRIPTION}
      inputDataFrame={dataFrame}
      visualizationConfig={visualizationConfig}
    />
  );
}
